var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 13.5C23.625 10.8147 22.5583 8.23935 20.6595 6.34054C18.7606 4.44174 16.1853 3.375 13.5 3.375C10.6694 3.38565 7.95259 4.49013 5.9175 6.4575L3.375 9M3.375 9V6.34054M3.375 9H5.9175M3.375 13.5C3.375 16.1853 4.44174 18.7606 6.34054 20.6595C8.23935 22.5583 10.8147 23.625 13.5 23.625C16.3306 23.6144 19.0474 22.5099 21.0825 20.5425L23.625 18M23.625 18H21.0825M23.625 18V20.6595",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.caaa68a21e82f1d71084d4be9def5c52.svg";
export { ForwardRef as ReactComponent };